export const BACKGROUND_COLOR_EXPERIMENT = 'backgroundColor';
export const GLADLY_CHAT_FLAGSHIP_KEY = 'GLADLY_CHAT';
export const PRODUCT_ORDER_KEY = 'productOrder';
export const OLLIE_APP_BANNER_KEY = 'OLLIE_APP_BANNER';
export const PRICE_PARITY_STARTING_AT_TEXT_KEY =
  'PRICE_PARITY_STARTING_AT_TEXT';
export const ENABLE_TURKEY_KEY = 'ENABLE_TURKEY';
export const PRICE_PARITY_PRICE_SYMBOL = 'price_parity_price_symbol';
export const SHOW_ADD_ONS_KEY = 'SHOW_ADD_ONS';
export const SHOW_ADD_ONS_ONBOARDING = 'SHOW_ADD_ONS_ONBOARDING';
export const SHOW_HALF_FRESH = 'SHOW_HALF_FRESH';
export const OLLIE_APP_FOOTER_DOWNLOAD_BUTTONS_KEY =
  'OLLIE_APP_FOOTER_DOWNLOAD_BUTTONS';
export const CAMPAIGN_TYPE = 'ab';
export const CHECKOUT_CONFIRMATION_OLLIE_APP_BANNER_KEY =
  'CHECKOUT_CONFIRMATION_OLLIE_APP_BANNER';
export const HIDE_BAKED_PLAN_TYPE_KEY = 'HIDE_BAKED_PLAN_TYPE';
export const IS_FRESH_ONLY_KEY = 'IS_FRESH_ONLY';
export const IS_FRESH_ONLY_MEMBER_EXPERIENCE =
  'IS_FRESH_ONLY_MEMBER_EXPERIENCE';
export const HIDE_BAKED_ONLY_MEMBER_EXPERIENCE =
  'HIDE_BAKED_ONLY_MEMBER_EXPERIENCE';
export const SHOW_HALF_FRESH_MEMBER_EXPERIENCE_EDIT_FLOW =
  'SHOW_HALF_FRESH_MEMBER_EXPERIENCE_EDIT_FLOW';
export const SHOW_HALF_FRESH_MEMBER_EXPERIENCE_ADD_PUP_AND_REACTIVATION_FLOWS =
  'SHOW_HALF_FRESH_MEMBER_EXPERIENCE_ADD_PUP_AND_REACTIVATION_FLOWS';
export const SHOW_PRICE_PER_DAY_KEY = 'SHOW_PRICE_PER_DAY';
export const flagshipData = {
  initialFlags: [
    {
      campaignType: 'toogle',
      key: 'SHOW_ADD_ONS',
      variationId: 'caqtvu2cn57g16mri14g',
    },
    {
      campaignType: 'ab',
      key: 'backgroundColor',
      variationId: 'cao3sane0j9g8tkq16k0',
    },
  ],
};
export const EXTRAS_PRICING_CUSTOMER_GROUP_ID =
  'EXTRAS_PRICING_CUSTOMER_GROUP_ID';
export const SHOW_PROMO_CODE_KEY = 'SHOW_PROMO_CODE_CHECKOUT';
export const SHOW_ORDER_HISTORY = 'SHOW_ORDER_HISTORY';
